import logout from '@Application/Security/Authentications/logout';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from '@verclam/synapse';

/** Returns a stable handler that ends the session, then sends the user to the login screen. */
const useLogout = (): (() => void) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	return React.useCallback(() => {
		dispatch(logout())
			.then(() => navigate('/login', { replace: true }))
			.catch(ignoreHandledError); // `logout()` never rejects today; kept for defensiveness.
	}, [dispatch, navigate]);
};

export default useLogout;
